// ¿LE FALTA ESTA PANTALLA DEL BÁSICO? La regla con la que se decide qué se le pregunta al que
// ya está dentro, y lo que se le pone delante del cuestionario largo (`QuestionnairePage`).
//
// UNA PREGUNTA OPCIONAL NO ES UN HUECO (30-10). «Algo más» se puede pasar en blanco a propósito
// y aun así salía la primera del largo, delante de «Tu salud», justo después de anunciarle la
// salud en «Pago confirmado». Además, ese falso hueco hacía que el envío del largo volviera a
// guardar el básico. La pantalla se marca con `opcional: true`.
export const falta = (paso, a) => {
    if (paso.opcional) return false;
    // «¿Estás seguro?» es la confirmación del objetivo: sin la pregunta del objetivo delante
    // no significa nada, y el que ya está dentro tiene objetivo desde el primer día.
    if (paso.key === '_confirm') return !a.goal;
    // El «pásala» de la mejor forma cuenta como contestada: no se le vuelve a pedir.
    if (paso.key === 'peso_mejor_momento' && a.mejor_forma_pasada) return false;
    if (paso.key) return a[paso.key] === undefined || a[paso.key] === null || a[paso.key] === '';
    // Las pantallas compuestas no tienen clave: se miran los campos que rellenan.
    if (paso.type === 'contacto') return !a.birthdate || !a.phone;
    if (paso.type === 'ocupacion') return !a.profesion;
    // Los siete biotipos, solo si le falta el suyo (y en mujer no salen nunca).
    if (paso.type === 'biotype_intro') return a.sex !== 'mujer' && !a.biotype;
    // El día tipo, solo si tampoco sabemos qué dieta sigue: si eso ya está, su día tipo lo
    // dio en su último ajuste y no hace falta pedírselo otra vez.
    if (paso.type === 'dieta') return a.sigue_dieta === undefined || a.sigue_dieta === null;
    return false;      // portadas, revisión y resultado: los pone el recorrido, no el filtro
};
